module.exports = __webpack_public_path__ + "static/media/galaxy20.db33a625.jpg";